/* eslint-disable */
import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import { IGetSeoUrlByUriRequest, TGetSeoUrlByUriModel, IMappers, TGetSeoUrlByUriResponse } from './types';
import { IPublicGetSeoUrlByUriV1ResponseSchema } from '../../entities/get_seo_url_by_uri/PublicGetSeoUrlByUriV1ResponseSchema';
import { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export const defaultConfig: TGetSeoUrlByUriModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'seo-urls',
  pathApi: '/v1/get-seo-url-by-uri/',
  responseType: 'json',
} as TGetSeoUrlByUriModel;

export function createGetSeoUrlByUriModel(parameters: IGetSeoUrlByUriRequest): TGetSeoUrlByUriModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetSeoUrlByUriOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetSeoUrlByUriRequest;
}

export async function fetchGetSeoUrlByUri<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetSeoUrlByUriOptions<TResponse200, TResponse400>): Promise<TGetSeoUrlByUriResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetSeoUrlByUriModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicGetSeoUrlByUriV1ResponseSchema);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetSeoUrlByUriResponse;
}
